import { Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  Router,
  RouterOutlet
} from '@angular/router';
import { LoadingPageComponent } from './shared/ui/loading-page/loading-page.component';
import { SmileLoaderComponent } from './shared/ui/smile-loader/smile-loader.component';
import { ToastComponent } from './shared/ui/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingPageComponent, ToastComponent, SmileLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private state = signal({ isLoading: true });
  isLoading = computed(() => this.state().isLoading);
  private destroyRef = inject(DestroyRef);

  constructor(private router: Router) {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError ||
        event instanceof NavigationSkipped
      ) {
        this.state.update(s => ({ ...s, isLoading: false }));
      }
    });
  }
}
